<template>
  <div>
    <v-card v-if="type === 'sekolah'" tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-list dense>
              <v-list-item class="px-0">
                <v-list-item-content class="py-0 px-1">
                  <v-row>
                    <v-col cols="12" lg="6">
                      <div class="body-2 grey--text">Laporan Bulan</div>
                      <div class="body-1 black--text">
                        {{ $getDeepObj(info, 'bulan') }}
                      </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <div class="body-2 grey--text">Fasilitator Pendamping</div>
                      <div class="body-1 black--text">
                        {{ $getDeepObj(info, 'fsp.ptk.nama') }}
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <div class="body-2 grey--text">Daftar Sekolah Pada Kelompok Pendampingan</div>
                      <div v-for="(kp, idKp) in sekolahs" :key="idKp">
                        <v-expansion-panels flat>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-0 body-1" style="min-height: unset">
                              {{ kp.nama }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="yellow lighten-5 pa-2 mt-2">
                              <v-row v-for="item in $getDeepObj(kp, 'psp_kp_pa_sekolahs') || []" :key="item.sekolah_id">
                                <v-col cols="12" md="6" sm="12">
                                  <v-list-item class="px-0">
                                    <v-list-item-avatar color="blue">
                                      <v-icon dark>mdi-hospital-building</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content class="py-0 px-1">
                                      <div class="blue--text body-1 mb-0 font-weight-medium">
                                        {{ $getDeepObj(item, 'sekolah.nama') || '-' }}
                                      </div>
                                      <div class="black--text">
                                        <span class="font-weight-medium">NPSN: </span>
                                        {{ $getDeepObj(item, 'sekolah.npsn') || '-' }}
                                      </div>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                                <v-col cols="12" md="3" sm="12">
                                  <v-list-item class="px-0" v-if="item.k_kp_kategori_psp">
                                    <v-list-item-content class="py-0">
                                      <v-list-item-title class="mb-0">
                                        <v-label color="caption"><small>Kategori Sekolah </small></v-label>
                                      </v-list-item-title>
                                      <div>
                                        <v-icon :color="kategoris[item.k_kp_kategori_psp]" class="mr-0" size="30">
                                          mdi-numeric-{{ item.k_kp_kategori_psp }}-circle
                                        </v-icon>
                                      </div>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mx-auto">
      <v-card-text class="pa-5 black--text">
        <v-row v-for="(kategori, id) in schema" :key="id">
          <v-col v-if="!kategori.hidden" cols="12">
            <div class="font-weight-medium mb-1" style="font-size: 20px"> {{ kategori.title }} </div>
            <base-form-generator :schema="kategori.laporan" v-model="form" class="pt-4">
              <template v-slot:selection="{ field, item, index }">
                <v-chip v-if="index === 0" small color="secondary lighten-1">
                  <span class="body-1">
                    {{ (form[field.name] || []).length }} / {{ listFspDampingan.length }} FSP
                    {{
                      field.name === 'absensi-disiplin' ? 'Laporan Terlambat' : type === 'progres' ? 'Absen' : 'Hadir'
                    }}
                  </span>
                </v-chip>
              </template>
            </base-form-generator>
          </v-col>
        </v-row>
        <template v-for="(schBerkas, id) in schemaBerkas">
          <v-row v-if="!schBerkas.hidden" :key="id">
            <v-col cols="12">
              <div class="font-weight-medium mb-2" style="font-size: 20px"> Lampiran {{ schBerkas.title }} </div>
              <div v-if="schBerkas.desc" class="body-2 grey--text mb-2">{{ schBerkas.desc }}</div>
              <v-row class="mt-1 mb-2">
                <div v-if="schBerkas.label"></div>
                <template>
                  <v-col v-if="(schBerkas.berkases || []).length" cols="12" sm="12" md="12" class="pt-1">
                    <v-row v-for="(file, f) in schBerkas.berkases" :key="f" dense>
                      <v-col cols="12" md="9" sm="12">
                        <div class="grey lighten-3 pa-2 black--text">{{ file.judul }}</div>
                      </v-col>
                      <v-col cols="12" md="3" sm="12" class="my-auto">
                        <div>
                          <v-btn
                            class="text-capitalize"
                            color="success"
                            depressed
                            :href="file.url_berkas"
                            target="_blank"
                          >
                            <v-icon left>mdi-eye</v-icon>
                            Lihat
                          </v-btn>
                          <v-btn
                            v-if="!isPreview"
                            class="mx-1 text-capitalize"
                            color="red"
                            dark
                            depressed
                            @click="onDelBerkas(file)"
                          >
                            <v-icon left>mdi-delete</v-icon>
                            Hapus
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    v-if="!(schBerkas.berkases || []).length && isPreview"
                    cols="12"
                    sm="12"
                    md="12"
                    class="pt-0 grey--text"
                  >
                    Belum ada berkas yang diunggah
                  </v-col>
                </template>
                <v-col v-if="!isPreview" cols="12" sm="12" md="12" class="py-0 mb-4">
                  <v-btn
                    class="text-capitalize"
                    color="primary"
                    depressed
                    :disabled="schBerkas.max && (schBerkas.berkases || []).length >= schBerkas.max"
                    @click="onAddBerkas(schBerkas)"
                  >
                    <v-icon left>mdi-plus</v-icon> Tambah Berkas
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <v-row v-if="isInputRekaman">
          <v-col cols="12">
            <div class="font-weight-medium mb-2" style="font-size: 20px"> Tautan Rekaman </div>
            <v-row v-for="(meeting, m) in form.rekaman_data" :key="m" no-gutters>
              <v-col cols="12" md="9">
                <base-form-generator
                  :key="m"
                  :schema="schemaMeetings"
                  v-model="form.rekaman_data[m]"
                  @input="getDurasi(form.rekaman_data[m], m)"
                />
                <div class="blue--text mt-4 ml-1 mb-2">
                  {{ (durasis && durasis[Number(m)]) || '' }}
                </div>
              </v-col>
              <v-col cols="12" md="3" sm="12" v-if="!isPreview">
                <div class="white--text">Aksi</div>
                <div class="ml-2">
                  <v-btn class="text-capitalize" color="error" depressed @click="onDelRekaman(m)">
                    <v-icon left>mdi-delete</v-icon> Hapus
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="3" sm="12" v-else>
                <div class="white--text">Aksi</div>
                <div class="ml-2">
                  <v-btn
                    class="mt-n2 text-capitalize"
                    color="success"
                    depressed
                    :href="$getDeepObj(form.rekaman_data[m], 'url_meeting')"
                    target="_blank"
                  >
                    <v-icon left>mdi-eye</v-icon>
                    Lihat
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="!(form.rekaman_data || []).length && isPreview">
              <v-col cols="12" class="grey--text">Belum ada rekaman yang diunggah</v-col>
            </v-row>
            <v-btn
              v-if="!isPreview"
              @click="onAddRekaman"
              color="primary"
              depressed
              class="text-capitalize"
              :disabled="form.rekaman_data.length >= 5"
            >
              <v-icon left dark>
                mdi-plus
              </v-icon>
              Tambah Tautan
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <form-berkas ref="berkas" :label="formUpload.label" :title="formUpload.title" @upload="onAddBerkasSave" />
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import FormBerkas from './Berkas';
import Instrumen from '../instrumen/Koordinator';
import InstrumenFkk2023 from '../instrumen/Fkk2023';
import InstrumenSekolah2023 from '../instrumen/Sekolah2023';
import InstrumenDaerah2023 from '../instrumen/Daerah2023';
import InstrumenPerkembangan2023 from '../instrumen/Perkembangan2023';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'FormKoordinator',
  mixins: [Instrumen, InstrumenFkk2023, InstrumenSekolah2023, InstrumenDaerah2023, InstrumenPerkembangan2023],
  components: { BaseFormGenerator, FormBerkas },
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    info: {
      type: Object,
      default: () => {},
    },
    berkases: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    sekolahs: {
      type: Array,
      default: () => [],
    },
    meta: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: { rekaman_data: [], absensi: {} },
      formUpload: {},
      durasis: [],
      kKoordinatorLaporan: {
        fasilitator: 1,
        sekolah: 2,
        daerah: 3,
        'progres-fsp': 4,
      },
      kategoris: {
        1: 'indigo',
        2: 'blue',
        3: 'cyan',
      },
    };
  },
  computed: {
    ...mapState('koordinatorFsp', {
      instrumens: (state) => state.instrumens,
    }),

    isInputRekaman() {
      const isModaRekaman = [1, 3].includes(+this.form.k_koordinator_moda_psp);

      if (+this.info.pendampingan_tahun >= 2023) {
        return isModaRekaman && this.type !== 'sekolah';
      }

      return isModaRekaman && ['fasilitator'].includes(this.type);
    },

    isInputFoto() {
      // if (this.type === 'fasilitator') {
      //   return [2, 3].includes(+this.form.k_koordinator_moda_psp);
      // }

      return true;
    },

    listFspDampingan() {
      return (this.meta.pa || []).map((pa) => {
        return {
          text: this.$getDeepObj(pa, 'ptk.nama'),
          value: pa.psp_profil_id,
        };
      });
    },
  },
  methods: {
    ...mapActions('preferensi', ['cekRekaman']),
    ...mapActions('koordinatorFsp', ['upload', 'delete']),

    reset() {
      this.$set(this, 'form', { rekaman_data: [] });

      const laporan = this.$getDeepObj(this.info, 'laporan.data') || {};

      for (const kKategori in this.schema) {
        const kategori = this.schema[kKategori] || {};

        for (const ins of kategori.laporan) {
          if (/checkbox/.test(ins.name)) {
            this.$set(this.form, ins.name, []);
          }
        }
      }

      // Init moda
      if (+this.info.pendampingan_tahun >= 2023 && ['sekolah'].includes(this.type)) {
        this.$set(this.form, 'k_koordinator_moda_psp', 1);
      }

      if (this.$isObject(laporan)) {
        if (['daerah', 'sekolah'].includes(this.type)) {
          this.$set(this.form, 'is_terlaksana', +laporan.is_terlaksana === 1 ? 1 : 0);

          if (this.type === 'sekolah') {
            this.$set(this.form, 'alasan_lain', laporan.alasan_lain || '');
          }
        }

        if (this.type === 'daerah') {
          if (laporan.k_propinsi) {
            this.$set(this.form, 'k_propinsi', laporan.k_propinsi);
          }

          if (laporan.k_kota) {
            this.$set(this.form, 'k_kota', laporan.k_kota);
          }
        }

        for (const kategori in this.schema) {
          for (const sch of this.$getDeepObj(this.schema, `${kategori}.laporan`) || []) {
            if (sch.name && sch.name !== 'is_terlaksana') {
              this.$set(this.form, sch.name, laporan[sch.name]);
            }
          }
        }

        // Init Meeting URL
        const meeting = this.$getDeepObj(laporan, 'rekaman_data') || [];
        if (meeting.length > 0) {
          this.$set(this.form, 'rekaman_data', []);
          let formMeeting = [];

          meeting.forEach((item, index) => {
            formMeeting.push(item);
            this.durasis[index] = this.$durasiWaktu(this.$getDeepObj(item, 'durasi')) || null;
          });

          this.$set(this.form, 'rekaman_data', formMeeting);
        }

        // Init PA
        const absensi = (
          this.$getDeepObj(laporan, 'psp_kp_pa_koordinator_laporan_absensis.data') || []
        ).filter((absen) => (this.type === 'fasilitator' ? +absen.is_hadir === 1 : +absen.is_hadir !== 1));
        const resultAbs = {};

        for (const abs of absensi) {
          if (resultAbs[abs.kelompok]) {
            resultAbs[abs.kelompok].push(abs.psp_profil_id);
          } else {
            resultAbs[abs.kelompok] = [];
            resultAbs[abs.kelompok].push(abs.psp_profil_id);
          }
        }

        for (const type of Object.keys(resultAbs)) {
          const typeAbs = type.split('-');
          const kelompok = typeAbs[1] || '';

          this.$set(this.form, kelompok ? `absensi-${kelompok}` : 'absensi', resultAbs[type]);
        }

        // Init Instrumen
        const instrumens = this.$getDeepObj(laporan, 'psp_kp_pa_koordinator_laporan_instrumens.data') || [];
        if (instrumens.length) {
          let result = {};
          for (const ins of instrumens) {
            const tipe = this.$getDeepObj(ins, 'm_koordinator_instrumen_psp.data.tipe') || '';

            if (tipe === 'checkbox') {
              if (result[`instrumen-${tipe}-${ins.k_koordinator_instrumen_psp}`]) {
                result[`instrumen-${tipe}-${ins.k_koordinator_instrumen_psp}`].push(ins.k_koordinator_opsi_psp);
              } else {
                result[`instrumen-${tipe}-${ins.k_koordinator_instrumen_psp}`] = [ins.k_koordinator_opsi_psp];
              }
            } else if (tipe === 'radio') {
              result[`instrumen-${tipe}-${ins.k_koordinator_instrumen_psp}`] = ins.k_koordinator_opsi_psp;
            } else {
              result[`instrumen-input-${ins.k_koordinator_instrumen_psp}`] = ins.isian || '';
            }

            if (ins.isian) {
              this.$set(
                this.form,
                `input-lain-${ins.k_koordinator_instrumen_psp}-${ins.k_koordinator_opsi_psp}`,
                ins.isian
              );
            }
          }

          for (const rs in result) {
            this.$set(this.form, rs, result[rs]);
          }
        }
      }
    },

    getDurasi(item, index) {
      if (!item.url_meeting) return;
      clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.cekRekaman({ rekaman_url: item.url_meeting }).then((resp) => {
          const duration = (resp && resp.videoMediaMetadata && resp.videoMediaMetadata.durationMillis) || null;
          if (duration) {
            this.$set(this.durasis, index, this.$durasiWaktu(duration));
          }
        });
      }, 1000);
    },

    getValue() {
      let values = Object.assign(
        {},
        {
          k_koordinator_laporan_psp: this.kKoordinatorLaporan[this.type],
          pendampingan_tahun: this.info.pendampingan_tahun,
          pendampingan_ke: this.info.pendampingan_ke,
        },
        this.form
      );

      if (this.type === 'sekolah') {
        values['psp_profil_id_pa'] = this.info.fsp.psp_profil_id;
        if (+values.is_terlaksana === 0) {
          values['k_koordinator_alasan_psp'] = 9;
        }

        for (const kKategori in this.schema) {
          const kategori = this.schema[kKategori] || {};

          for (const instrumen of kategori.laporan) {
            if (instrumen.name === 'is_terlaksana') {
              continue;
            }

            if (+values.is_terlaksana === 1) {
              if (['k_koordinator_alasan_psp', 'alasan_lain'].includes(instrumen.name)) {
                delete values[instrumen.name];
              }
            } else {
              if (!['k_koordinator_alasan_psp', 'alasan_lain'].includes(instrumen.name)) {
                delete values[instrumen.name];
              }
            }
          }
        }
      }

      if (this.type === 'daerah') {
        if (+values.is_terlaksana === 1) {
          delete values['k_koordinator_alasan_psp'];
          delete values['alasan_lain'];
        } else {
          delete values['tgl_pelaksanaan'];
          delete values['k_koordinator_moda_psp'];
          delete values['k_propinsi'];
          delete values['k_kota'];

          if (+values['k_koordinator_alasan_psp'] !== 9) {
            delete values['alasan_lain'];
          }
        }
      }

      const keysInstrumens = Object.keys(values).filter((key) => /instrumen/.test(key));
      for (const key of keysInstrumens) {
        const keys = key.split('-');
        const tipe = keys[1];
        const kKoordinatorInstrumen = keys[2];

        let result = [];
        if (tipe === 'checkbox') {
          result = (values[key] || []).map((value) => {
            return {
              k_koordinator_instrumen_psp: kKoordinatorInstrumen,
              k_koordinator_opsi_psp: value,
              isian: values[`input-lain-${kKoordinatorInstrumen}-${value}`] || '',
            };
          });
        } else {
          if (values[key]) {
            if (tipe === 'radio') {
              result = [
                {
                  k_koordinator_instrumen_psp: kKoordinatorInstrumen,
                  k_koordinator_opsi_psp: values[key],
                  isian: values[`input-lain-${kKoordinatorInstrumen}-${values[key]}`] || '',
                },
              ];
            } else {
              result = [
                {
                  k_koordinator_instrumen_psp: kKoordinatorInstrumen,
                  isian: values[key],
                },
              ];
            }
          }
        }

        if (values.instrumen) {
          values.instrumen = [...values.instrumen, ...result];
        } else {
          values.instrumen = result;
        }

        delete values[key];
      }

      const inputsLain = Object.keys(values).filter((key) => /input-lain/.test(key));
      for (const input of inputsLain) {
        delete values[input];
      }

      if (+this.info.pendampingan_tahun >= 2023 && ['fasilitator', 'progres-fsp'].includes(this.type)) {
        const absensi = [];

        const typesAsensi = Object.keys(this.form).filter((key) => /absensi/.test(key));
        for (const typeAbs of typesAsensi) {
          const type = typeAbs.split('-');

          for (const pspProfil of this.meta.pa || []) {
            absensi.push({
              psp_profil_id: pspProfil.psp_profil_id,
              kelompok: type[1] ? `progres-${type[1]}` : this.type,
              is_hadir: (this.form[typeAbs] || []).includes(pspProfil.psp_profil_id)
                ? this.type === 'fasilitator'
                  ? 1
                  : 0
                : this.type === 'fasilitator'
                ? 0
                : 1,
            });
          }

          delete values[typeAbs];
        }

        values = Object.assign({}, values, { absensi });
      }

      return values;
    },

    onAddBerkas(berkas) {
      this.$set(this.formUpload, 'label', berkas.label);
      this.$set(this.formUpload, 'title', berkas.title);

      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onAddBerkasSave(berkas) {
      const params = new FormData();

      params.append('label', this.formUpload.label);
      params.append('judul', berkas.judul);
      params.append('file', berkas.file);
      params.append('k_koordinator_laporan_psp', this.kKoordinatorLaporan[this.type]);
      params.append('pendampingan_ke', this.info.pendampingan_ke);
      params.append('pendampingan_tahun', this.info.pendampingan_tahun);

      if (this.type === 'sekolah') {
        params.append('psp_profil_id_pa', this.info.fsp.psp_profil_id);
      }

      this.$refs.berkas.startLoading();
      this.upload({ params })
        .then(() => {
          this.$emit('refresh', this.info.pendampingan_ke);
          this.$success('Berkas berhasil diunggah');
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },

    onDelBerkas(berkas) {
      const id = this.$getDeepObj(berkas, `psp_kp_pa_koordinator_laporan_berkas_id`);
      this.$confirm(`Apakah Anda yakin ingin menghapus berkas <b>${berkas.judul}</b> ?`, 'Peringatan', {
        tipe: 'error',
      }).then(() => {
        this.delete({ id }).then(() => {
          this.$success('Berkas berhasil dihapus');
          this.$emit('refresh', this.info.pendampingan_ke);
        });
      });
    },

    onAddRekaman() {
      this.form.rekaman_data.push({ url_meeting: '' });
    },

    onDelRekaman(index) {
      this.form.rekaman_data.splice(index, 1);
      this.$delete(this.durasis, index);
    },

    onAddTindakLanjut() {},
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
